// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1u90G","bigColWidth":"Table_bigColWidth__3KjHY","biggerColWidth":"Table_biggerColWidth__3l1Qt","row":"Table_row__1-7PW","col":"Table_col__1symw"};